/* The mockup's `.pv-banner`: a floating pill at the top of the canvas. */
.banner {
  position: absolute;
  z-index: 3;
  inset-block-start: var(--space-2);
  inset-inline-start: 50%;
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: 4px 4px 4px 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius-pill);
  background: var(--surface-raised);
  box-shadow: var(--shadow-popover);
  font-size: var(--font-size-13);
  white-space: nowrap;
  transform: translateX(-50%);
}
